import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27ce3f06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "leftTitlt" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "redLine1" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "redLine2" }, null, -1))



  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeftTitle',
  props: ['title'],
  setup(__props) {

const props = __props;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString(_unref(props).title), 1)
  ]))
}
}

})